import { ReactNode } from 'react';
import backgroundImg from 'assets/images/background.png';
import MainLayout from 'layouts/MainLayout';
import PublicThemeProvider from './PublicThemeProvider';

interface ILayoutWithBGProps {
  children: ReactNode;
}

const LayoutWithBG = ({ children }: ILayoutWithBGProps) => {
  return (
    <PublicThemeProvider>
      <MainLayout
        sx={{
          background: {
            xs: `url(${backgroundImg}) lightgray -315.665px -280px / 268.363% 199.747% no-repeat`,
            md: `url(${backgroundImg}) lightgray -80.899px -485.263px / 109.635% 387.792% no-repeat`,
          },
        }}>
        {children}
      </MainLayout>
    </PublicThemeProvider>
  );
};

export default LayoutWithBG;
